import * as React from 'react';
import { LayerWrapper } from '@volkswagen-onehub/components-core';
import { AlertLayer, ContentLayerV2, CustomLayer, DisclaimerLayer, FocusLayer, FullscreenLayer, InteractionLayer, } from './layers';
import { Shim } from './shim';
function getDisclaimerLayer(layerManager) {
    return 'getDisclaimerLayer' in layerManager
        ? layerManager.getDisclaimerLayer()
        : undefined;
}
export class LayerManagerComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            nonDisclaimerLayers: this.props.layerManager.getLayers(),
            disclaimerLayer: getDisclaimerLayer(this.props.layerManager),
        };
        this.createRef = (id, el) => {
            this.props.layerManager.onRender(id, el);
        };
        this.update = (event) => {
            if (!event || event === 'update') {
                this.forceUpdate();
            }
        };
    }
    static getDerivedStateFromProps(props) {
        return {
            nonDisclaimerLayers: props.layerManager.getLayers(),
            disclaimerLayer: getDisclaimerLayer(props.layerManager),
        };
    }
    shouldComponentUpdate(_nextProps, nextState) {
        return (this.state.nonDisclaimerLayers !== nextState.nonDisclaimerLayers ||
            this.state.disclaimerLayer !== nextState.disclaimerLayer);
    }
    componentDidMount() {
        this.listener = this.props.layerManager.subscribe(this.update);
    }
    componentWillUnmount() {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    }
    renderLayer(layerDescription, active) {
        const { close, id, options } = layerDescription.layer;
        switch (layerDescription.type) {
            case 'ALERT':
                return (React.createElement(AlertLayer, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'CONTENT':
                return React.createElement("span", null, "was removed");
            case 'CONTENTV2':
                return (React.createElement(ContentLayerV2, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'FOCUS':
                return (React.createElement(FocusLayer, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'INTERACTION':
                return (React.createElement(InteractionLayer, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'DISCLAIMER':
                return (React.createElement(DisclaimerLayer, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'FULLSCREEN':
                return (React.createElement(FullscreenLayer, { layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
            case 'CUSTOM':
                return (React.createElement(CustomLayer, { disableReturnFocus: options.disableReturnFocus, layer: layerDescription.layer, active: active, key: id, onEscKeyUp: options.userCloseable ? close : undefined, scrollElementRef: (el) => {
                        this.createRef(id, el);
                    } }));
        }
    }
    render() {
        const { nonDisclaimerLayers, disclaimerLayer } = this.state;
        /**
         * FIXME: `contentCentered` is necessary because of a backward-incompatible change in
         * `LayerWrapper`, hiding styles which are necessary for the correct display behind a
         * new styling prop `contentCentered`.
         * See https://github.com/volkswagen-onehub/components-core/commit/3909a4b9ca104716d52ac65ac68e5e3f70f42f79
         */
        return (React.createElement(LayerWrapper, { contentCentered: true },
            nonDisclaimerLayers.map((layerDescription, index) => {
                const { type, layer } = layerDescription;
                const isTopLayer = index === nonDisclaimerLayers.length - 1;
                const isLayerCloseable = layerDescription.layer.options.userCloseable;
                const shimBackgroundType = layerDescription.layer.options.shimBackgroundType;
                const closeButton = layerDescription.layer.options.closeButton;
                return [
                    isTopLayer && (React.createElement(Shim, { key: "shim", layerType: type, backgroundType: shimBackgroundType, onClick: isLayerCloseable ? layer.close : undefined })),
                    isTopLayer && closeButton,
                    this.renderLayer(layerDescription, isTopLayer),
                ];
            }),
            disclaimerLayer && this.renderLayer(disclaimerLayer, true)));
    }
}
//# sourceMappingURL=layer-manager-component.js.map